import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';

/**
 * Themed delete confirmation. Pass `colors` from `tokens(theme.palette.mode)`.
 */
export default function ConfirmDeleteDialog({
  open,
  onClose,
  onConfirm,
  title = 'Delete?',
  message = 'Are you sure you want to delete this item?',
  colors,
  isLoading = false,
  confirmLabel = 'Yes, delete',
}) {
  if (!colors) return null;
  return (
    <Dialog
      open={open}
      onClose={isLoading ? undefined : onClose}
      maxWidth="xs"
      fullWidth
      aria-labelledby="confirm-delete-title"
      PaperProps={{
        sx: {
          backgroundColor: colors.primary[500],
          borderRadius: 2,
          border: `1px solid ${colors.grey[700]}`,
          boxShadow: '0 16px 48px rgba(0,0,0,0.35)',
        },
      }}
    >
      <DialogTitle
        id="confirm-delete-title"
        sx={{
          backgroundColor: colors.primary[500],
          color: colors.grey[100],
          fontWeight: 700,
          fontSize: '1.15rem',
          px: 3,
          pt: 2.5,
          pb: 1,
        }}
      >
        {title}
      </DialogTitle>
      <DialogContent
        sx={{
          backgroundColor: colors.primary[500],
          px: 3,
          pt: 2.5,
          pb: 1,
        }}
      >
        <Typography variant="body1" color={colors.grey[100]} sx={{ lineHeight: 1.6, mb: 1.5 }}>
          {message}
        </Typography>
        <Typography variant="body2" color={colors.grey[400]} sx={{ lineHeight: 1.55 }}>
          This action cannot be undone.
        </Typography>
      </DialogContent>
      <DialogActions
        sx={{
          backgroundColor: colors.primary[500],
          px: 3,
          py: 2,
          gap: 1.5,
          justifyContent: 'flex-end',
        }}
      >
        <Button
          onClick={onClose}
          variant="outlined"
          disabled={isLoading}
          sx={{
            borderColor: colors.grey[600],
            color: colors.grey[200],
            fontWeight: 600,
            borderRadius: 2,
            px: 2.5,
            py: 0.75,
            textTransform: 'none',
            '&:hover': {
              borderColor: colors.grey[400],
              backgroundColor: 'rgba(255,255,255,0.04)',
            },
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color="error"
          disabled={isLoading}
          autoFocus
          sx={{
            fontWeight: 600,
            borderRadius: 2,
            px: 2.5,
            py: 0.75,
            textTransform: 'none',
            boxShadow: 'none',
            '&:hover': {
              boxShadow: 'none',
              opacity: 0.92,
            },
          }}
        >
          {isLoading ? 'Deleting…' : confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
